import { useEffect, useState } from 'react';

const navLinks = [
  { label: '首页', href: '#home' },
  { label: '热门漫画', href: '#featured' },
  { label: '漫画分类', href: '#categories' },
  { label: '阅读体验', href: '#features' },
  { label: '用户口碑', href: '#testimonials' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg" />
          </span>
          <span className={`font-heading text-xl ${scrolled || open ? 'text-foreground-950' : 'text-foreground-950'}`}>
            咪咕漫画网
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100/70 hover:text-primary-700 whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            下载 APP
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur-md">
          <ul className="mx-auto max-w-7xl space-y-1 px-4 py-4">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#download"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 hover:bg-primary-600"
              >
                下载 APP
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}